export const actionTypes = {
    INIT_ACCOUNT_INFO: 'INIT_ACCOUNT_INFO'
}

export const initAccountInfo = data => {
    return {
        type: actionTypes.INIT_ACCOUNT_INFO,
        payload: data
    }
}